// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { ProjectTemplate } from "../../types";

const projectTemplatesModule = {
  async findByUserId(userId: string): Promise<ProjectTemplate[]> {
    const result = await sql`
      SELECT * FROM project_templates
      WHERE user_id = ${userId} OR is_system = true
      ORDER BY is_system DESC, position ASC, created_at DESC
    `;
    return (result || []) as ProjectTemplate[];
  },

  async create(data: Omit<ProjectTemplate, 'id' | 'created_at' | 'updated_at'>): Promise<ProjectTemplate> {
    const result = await sql`
      INSERT INTO project_templates (user_id, title, description, is_system, position)
      VALUES (${data.user_id}, ${data.title}, ${data.description}, ${data.is_system}, ${data.position})
      RETURNING *
    `;
    return result[0] as ProjectTemplate;
  },

  async update(id: string, userId: string, data: Partial<ProjectTemplate>): Promise<ProjectTemplate> {
    const result = await sql`
      UPDATE project_templates
      SET title = COALESCE(${data.title}, title),
          description = COALESCE(${data.description}, description),
          position = COALESCE(${data.position}, position),
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as ProjectTemplate;
  },

  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM project_templates
      WHERE id = ${id} AND user_id = ${userId} AND is_system = false
    `;
    return result.count > 0;
  }
};

export type ProjectTemplatesModule = typeof projectTemplatesModule;

export function registerProjectTemplates(db: { projectTemplates?: ProjectTemplatesModule }) {
  db.projectTemplates = projectTemplatesModule;
}

export { projectTemplatesModule as projectTemplates };
